import { Box, Container, Grid, ToggleButtonGroup, ToggleButton, Paper, Typography, Button } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { Kpis } from './components/kpis.component'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import './components/GroupsPage.css'
import { HeatMapComponent } from './components/heatmap'
import { TagRecap } from './components/tag-recap'
import SortableDataGrid from './components/table'
import { DownloadButton } from './components/download'
import { averages, hotels } from './components/variables'
import { ScatterComponent } from './components/scatter.component'
import { GroupMapComponent } from '../newdashboard/components/maps-group.component'
import { RowBarComponent } from './components/row-bar.component'
import { DoughnutChart } from './components/doughnut.component'
import { useDemoSites } from './hooks/useDemoSites'
import Loader from '@/components/fallbacks/loader.component'
import PerimeterFilters from './components/filters/perimeterFilters.component'
import FilterListIcon from '@mui/icons-material/FilterList'
import { MapChart } from './components/map.component'
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { CalendarComponent } from './components/calendar.component'
import { computeKpis } from './utils'
import { filterSiteDataByYear } from './filterSeriesData'

export const GroupsPage = () => {
    const { data = [], isLoading, filterMethods, filterOptions } = useDemoSites()
    const { filterSites } = filterMethods
    const sites = filterSites(data)
    const [comparison, setComparison] = useState(false)
    const [displayFilters, setDisplayFilters] = useState(false)
    const [comparisonItems, setComparisonItems] = useState(['*'])
    const [selectedHotels, setSelectedHotels] = useState([])
    const [year, setYear] = useState(moment().year())
    const kpis = useMemo(() => computeKpis({ sites, year }), [sites, year])

    const tags = hotels.reduce((acc, hotel) => {
        hotel.tags.forEach((tag) => {
            let find = acc?.find((el) => el?.name == tag?.name && el?.type == tag?.type)
            if (!find) {
                acc.push(tag)
            }
        })
        return acc
    }, [])

    useEffect(() => {
        console.log('comparison', comparison)
        if (comparison) {
            // get the two first tags
            let first_tag = tags[0]
            let type = first_tag?.type
            let second_tag = tags?.filter((tag) => tag?.type == type)?.[1]
            let _comparisonItems = [
                {
                    tag: first_tag,
                    surface: hotels
                        ?.filter((hotel) => hotel.tags.includes(first_tag))
                        ?.reduce((acc, hotel) => acc + hotel.surface, 0),
                    hotel_total: hotels?.filter((hotel) => hotel.tags.includes(first_tag))?.length,
                },
                {
                    tag: second_tag,
                    surface: hotels
                        ?.filter((hotel) => hotel.tags.includes(second_tag))
                        ?.reduce((acc, hotel) => acc + hotel.surface, 0),
                    hotel_total: hotels?.filter((hotel) => hotel.tags.includes(second_tag))?.length,
                },
            ]
            update(_comparisonItems)
            // setComparisonItems(['Fond A', 'Fond A'])
        } else {
            setComparisonItems(['*'])
            setSelectedHotels([...hotels, ...averages]?.sort((a, b) => a?.consoBrute - b?.consoBrute))
        }
    }, [comparison])

    const update = (_comparisonItems) => {
        setComparisonItems(_comparisonItems)
        let _newHotels =
            _comparisonItems?.length == 1
                ? hotels
                : hotels?.filter((hotel) => {
                      let find = hotel?.tags.find(
                          (tag) =>
                              (tag?.name == _comparisonItems[0]?.tag?.name &&
                                  tag?.type == _comparisonItems[0]?.tag?.type) ||
                              (tag?.name == _comparisonItems[1]?.tag?.name &&
                                  tag?.type == _comparisonItems[1]?.tag?.type)
                      )
                      return find
                  })
        _newHotels = [..._newHotels, ...averages]?.sort((a, b) => a?.consoBrute - b?.consoBrute)
        setSelectedHotels(_newHotels)
    }

    const xLabels = Array.from({ length: 12 }, (_, i) => moment().month(i).format('MMM'))
    const yLabels = ["ELECTRICITY", "HEAT", "GAS"]

    const generateMatrixFromKPIs = (kpis) => {
        // Initialize the matrix with zeros
        const matrix = Array.from({ length: yLabels.length }, () => Array(xLabels.length).fill(0))

        // Helper function to get the value for a specific type and month
        const getValueForTypeAndMonth = (type, month, kpis) => {
            const kpi = kpis.find((kpi) => kpi?.subType == type)
            if (!kpi) return 0
            const seriesItem = kpi.series.find((item) => moment(item.date).format('MMM') === month)

            return (seriesItem ? seriesItem.value : 0)// / kpi?.value
        }

        // Populate the matrix with values from KPIs
        for (let i = 0; i < yLabels.length; i++) {
            for (let j = 0; j < xLabels.length; j++) {
                matrix[i][j] = parseInt(getValueForTypeAndMonth(yLabels[i], xLabels[j], kpis) * 100)
            }
        }

        return matrix
    }

    useEffect(() => {
        if (filterMethods.filters.length == 0) {
            setDisplayFilters(false)
        }
    }, [filterMethods.filters])
    if (isLoading) {
        return <Loader />
    }
    console.dir(sites)

    return (
        // <Layout title="Group" showSites={false} showNavCalendar={true}>
        <Container sx={{ p: 2 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img
                        src="https://extendam.com/wp-content/uploads/2019/08/logo_extendam.png"
                        alt="Extendam"
                        style={{
                            width: 100,
                            // height: 100,
                            objectFit: 'contain',
                        }}
                    />
                    <ToggleButtonGroup
                        value={comparison}
                        exclusive
                        onChange={() => setComparison(!comparison)}
                        style={{ marginLeft: 20 }}
                    >
                        <ToggleButton value={false} aria-label="left aligned">
                            Vue globale
                        </ToggleButton>
                        <ToggleButton value={true} aria-label="centered">
                            Comparaison
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <CalendarComponent year={year} setYear={setYear} />
            </div>
            <Paper variant="outlined" sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline' }}>
                        <Typography variant="h6">Périmètre</Typography>
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            color="text.secondary"
                        >{`- ${sites?.length} hôtels`}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline' }}>
                        <Button
                            size="small"
                            startIcon={<FilterListIcon />}
                            onClick={() => setDisplayFilters(!displayFilters)}
                            // disabled={displayFilters}
                        >
                            Filtrer
                        </Button>
                        <DownloadButton size="small" />
                    </Box>
                </Box>
                {displayFilters && <PerimeterFilters filterOptions={filterOptions} {...filterMethods} />}
            </Paper>

            <Grid container spacing={4}>
                <TransitionGroup component={null}>
                    {comparisonItems.map((el, index) => (
                        <CSSTransition key={el?.tag?.name} timeout={500} classNames="fade">
                            <>
                                <Grid item md={12 / comparisonItems.length}>
                                    <Grid container spacing={2}>
                                        <Grid item md={12}>
                                            {el?.tag?.name ? (
                                                <TagRecap
                                                    {...el}
                                                    name={el.tag?.name}
                                                    tags={tags}
                                                    index={index}
                                                    type={el?.tag?.type}
                                                    blacklist={comparisonItems
                                                        ?.map((item) => item?.tag?.name)
                                                        ?.filter((item) => item != el?.tag?.name)}
                                                    onChange={(oldTag, newTag) => {
                                                        console.log('oldTag', oldTag)
                                                        console.log('newTag', newTag)
                                                        let _comparisonItems = comparisonItems
                                                        let oldIndex = _comparisonItems
                                                            ?.map((el) => el?.tag?.name)
                                                            .indexOf(oldTag)
                                                        let first_tag = tags?.find((el) => el?.name == newTag)
                                                        _comparisonItems[oldIndex] = {
                                                            tag: first_tag,
                                                            surface: hotels
                                                                ?.filter((hotel) => hotel.tags.includes(first_tag))
                                                                ?.reduce((acc, hotel) => acc + hotel.surface, 0),
                                                            hotel_total: hotels?.filter((hotel) =>
                                                                hotel.tags.includes(first_tag)
                                                            )?.length,
                                                        }
                                                        console.log('_comparisonItems', _comparisonItems)
                                                        update(_comparisonItems)
                                                    }}
                                                />
                                            ) : null}
                                        </Grid>
                                        <Grid item md={12}>
                                            <Kpis
                                                width={comparisonItems.length * 4}
                                                name={el?.tag?.name}
                                                sites={sites}
                                                year={year}
                                                kpis={kpis}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        </CSSTransition>
                    ))}
                    <CSSTransition key={`map-${hotels?.length}`} timeout={500} classNames="fade">
                        <>
                            <Grid item md={6}>
                                <MapChart data={sites?.map((el) => el?.countryCode)} />
                                {/* <GroupMapComponent
                                sites={selectedHotels?.map((el) => {
                                    return {
                                        ...el,
                                        SiteId: el.id,
                                        Name: el.name,
                                        Address: el.address,
                                        Latitude: el.latitude,
                                        Longitude: el.longitude,
                                    }
                                })}
                                onSelect={() => {}}
                                style={{ width: '100%', height: 300, zIndex: 0 }}
                                disableClick={true}
                                fullscreenControl={false}
                                key={`map-components}`}
                            /> */}
                            </Grid>
                            <Grid item md={6}>
                                <Grid container spacing={2}>
                                    {comparisonItems.map((el, index) => (
                                        <>
                                            <Grid item md={12}>
                                                <RowBarComponent
                                                    title="Top 3 DPE"
                                                    hotels={sites
                                                        ?.sort((a, b) => {
                                                            return (
                                                                a?.dpe?.consumption?.value - b?.dpe?.consumption?.value
                                                            )
                                                        })
                                                        ?.filter((hotel, index) => {
                                                            return index < 3
                                                        })}
                                                    icon={<ThumbUpIcon style={{ color: '#00e676' }} />}
                                                    color="#b9f6ca"
                                                />
                                            </Grid>
                                            <Grid item md={12}>
                                                <RowBarComponent
                                                    title="Low 3 DPE"
                                                    hotels={sites
                                                        ?.sort((a, b) => {
                                                            return (
                                                                -a?.dpe?.consumption?.value + b?.dpe?.consumption?.value
                                                            )
                                                        })
                                                        ?.filter((hotel, index) => {
                                                            return index < 3
                                                        })}
                                                    icon={<ThumbDownAltIcon style={{ color: 'red' }} />}
                                                    color="#ffab91"
                                                />
                                            </Grid>
                                            {/* <Grid item md={comparisonItems.length == 1 ? 4 : 6}>
                                                <DoughnutChart title="Etoiles" />
                                            </Grid> */}
                                        </>
                                    ))}
                                </Grid>
                            </Grid>
                        </>
                    </CSSTransition>
                    {comparisonItems.map((el, index) => (
                        <CSSTransition key={el?.tag?.name} timeout={500} classNames="fade">
                            <>
                                <Grid item md={12 / comparisonItems.length}>
                                    <Grid container spacing={2}>
                                        <Grid item md={6 * comparisonItems.length}>
                                            <HeatMapComponent
                                                data={generateMatrixFromKPIs(kpis)}
                                                xLabels={xLabels}
                                                yLabels={yLabels}
                                            />
                                        </Grid>
                                        <Grid item md={6 * comparisonItems.length}>
                                            <ScatterComponent hotels={sites} tags={tags} comparisonItem={el} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        </CSSTransition>
                    ))}

                    {/* <CSSTransition key={`bar-grid-${hotels?.length}`} timeout={500} classNames="fade">
                        <Grid item md={12}>
                            <BarChartComponent comparisonItems={comparisonItems} />
                        </Grid>
                    </CSSTransition> */}
                    <CSSTransition key={`sortable-grid-${hotels?.length}`} timeout={500} classNames="fade">
                        <Grid item md={12}>
                            <SortableDataGrid hotels={sites.map((s) => filterSiteDataByYear(s, year))} />
                        </Grid>
                    </CSSTransition>
                </TransitionGroup>
            </Grid>
        </Container>
        // </Layout>
    )
}
